import React, { useEffect } from 'react'

export default function NotFound() {
    useEffect(() => {
        window.location.replace("/login")
    }, [])
    return (
        <div>
            Not Found
        </div>
    )
}
